import { connect } from "react-redux";

import Screen from "../../components/screen";
import { uiStateSelectors } from "../../modules/uiState";

let SmartScreen = Screen;

//#!if mobile === true
// const mapStateToProps = (state, _props) => {
// const deviceInsets = uiStateSelectors.getDeviceInsets(state.present);
// return {
// paddingLeft: deviceInsets.left,
// paddingRight: deviceInsets.right
// };
// };
// 
// SmartScreen = connect(mapStateToProps, null)(Screen);
//#!endif

export default SmartScreen;
